import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tangy-loading',
  templateUrl: './tangy-loading.component.html',
  styleUrls: ['./tangy-loading.component.css']
})
export class TangyLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
